import type { OrderStatus, PaymentMethod } from "@/lib/api/types";

const ONLINE_INVOICE_STATUSES: ReadonlySet<OrderStatus> = new Set([
  "confirmed",
  "preparing",
  "shipped",
  "delivered",
]);

/**
 * Whether an order should have an invoice generated yet. Mirrors the backend
 * triggers: online orders get one once payment is confirmed; COD orders only
 * once delivered (cash collected). Generation is async, so the UI still
 * handles a "not ready" response gracefully.
 */
export function isInvoiceAvailable(
  paymentMethod: PaymentMethod,
  status: OrderStatus,
): boolean {
  if (paymentMethod === "COD") {
    return status === "delivered";
  }
  return ONLINE_INVOICE_STATUSES.has(status);
}
